import { MANTENIMIENTO_VER } from '../utils/mantenimiento'
import { entraAComercial, tieneFuncionComercial, puedeEntrar } from './espaciosLogica'

// Who sees Órdenes de trabajo (Operaciones > Planta): whoever holds some OT
// function (the server sends them in /auth/me as ot_funciones), never a role.
// Each step inside is checked by its own function.
export const entraAOt = (user) => (user?.ot_funciones || []).length > 0

export { entraAComercial, tieneFuncionComercial, puedeEntrar }

// The app's workspaces: where each opens and who may enter (by `roles`, or by
// `entra(user)` for one gated by function). Layout draws the switcher from
// these; App uses them for the workspace a user chose to start on
// (user.espacio_inicio, set from the switcher).
export const ESPACIOS = {
  engineering:  { home: '/',                     roles: ['admin', 'pm_po', 'engineer'] },
  // Everyone who sees Mantenimiento (utils/mantenimiento.js).
  operations:   { home: '/operations/planta/ot', roles: MANTENIMIENTO_VER,
                  // Also opens for whoever holds an OT function (the server decides each step by function, not by role).
                  entra: (user, roles = user?.roles || []) => MANTENIMIENTO_VER.some(r => roles.includes(r)) || entraAOt(user) },
  acquisitions: { home: '/purchases',            roles: ['admin', 'pm_po', 'engineer', 'purchaser'] },
  crm:          { home: '/crm',                  roles: ['admin', 'commercial'] },
  comercial:    { home: '/comercial',            roles: [], entra: entraAComercial },
  c_level:      { home: '/c-level',              roles: ['admin', 'c_level'] },
  // RRHH gets people, accounts, areas, calendar and Contratos; c_level Contratos only.
  admin:        { home: '/admin/personas',       roles: ['admin', 'rrhh', 'c_level'] },
}

// Where a workspace opens for these roles: Operaciones opens on Unidades for
// someone who sees Mantenimiento but not the work orders; Administración on
// Contratos for someone who is neither admin nor RRHH.
export function homeDe(id, user) {
  const roles = user?.roles || []
  if (id === 'operations' && !entraAOt(user)) return '/operations/unidades'
  if (id === 'admin' && !roles.includes('admin') && !roles.includes('rrhh')) return '/admin/contratos'
  return ESPACIOS[id]?.home
}

// The chosen start workspace's home, if the user may enter it.
export function inicioDe(user, roles) {
  const id = user?.espacio_inicio
  const e = id && ESPACIOS[id]
  return puedeEntrar(e, user, roles) ? homeDe(id, user) : null
}
